import React from 'react'
import { Link } from 'react-router-dom'

import { Logo } from './Header.styles'

import { useWhitelabel } from 'main/framework'
import { userDashboardPath } from 'main/routes'
import { Hidden, LogoIcon, Visible } from 'main/ui'
import { AssetName } from 'main/util/asset'

const WONDERSCHOOL_LOGO = 'https://ucarecdn.com/c1303c54-e765-4c61-bdc0-3922e768c490/-/format/auto/'

interface IProps {
  disableLogoLink?: boolean
  showSearchForm?: boolean
}

export default function LinkedLogo(props: IProps) {
  const { disableLogoLink, showSearchForm } = props
  const whitelabel = useWhitelabel()

  const logo = whitelabel.getAsset(AssetName.LOGO)
  const logoSmall = whitelabel.getAsset(AssetName.LOGO_SMALL)
  const logoLinkUrl = whitelabel.getAsset(AssetName.LOGO_LINK_URL)

  const large = largeVersion(logoLinkUrl, disableLogoLink, logo)
  const small = smallVersion(logoLinkUrl, disableLogoLink, logoSmall)

  return (
    <>
      <Visible lg xl>
        {large}
      </Visible>
      <Hidden lg xl>
        {showSearchForm ? small : large}
      </Hidden>
    </>
  )
}

function smallVersion(
  logoPath: string | undefined,
  disableLogoLink?: boolean,
  logo?: string | null,
) {
  const smallGuts =
    logo && logo !== '' ? (
      <img src={`${logo}-/resize/40x/-/quality/smart/`} />
    ) : (
      <div css={{ width: '30px' }}>
        <LogoIcon />
      </div>
    )

  return linkOrAtag(smallGuts, logoPath, disableLogoLink)
}

function largeVersion(
  logoPath: string | undefined,
  disableLogoLink?: boolean,
  logo?: string | null,
) {
  const largeGuts =
    logo && logo !== '' ? (
      <img style={{ maxWidth: '200px' }} src={`${logo}-/resize/400x/-/quality/smart_retina/`} />
    ) : (
      <Logo src={WONDERSCHOOL_LOGO} />
    )

  return linkOrAtag(largeGuts, logoPath, disableLogoLink)
}

function linkOrAtag(guts: any, logoPath: string | undefined, disableLogoLink?: boolean) {
  const url = disableLogoLink ? '#' : userDashboardPath()

  return !disableLogoLink && logoPath ? <a href={logoPath}>{guts}</a> : <Link to={url}>{guts}</Link>
}
